import React from "react";

export const Sparkline = ({ data = [], color = "#00ff95", width = 80, height = 24 }) => {
    if (!data || data.length < 2) return <div style={{ width, height }} />;
    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min || 1;
    const stepX = width / (data.length - 1);
    const points = data
        .map((v, i) => `${(i * stepX).toFixed(2)},${(height - ((v - min) / range) * height).toFixed(2)}`)
        .join(" ");
    const up = data[data.length - 1] >= data[0];
    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
            <polyline
                fill="none"
                stroke={up ? "var(--green)" : "var(--red)"}
                strokeWidth="1.5"
                points={points}
                style={{ color }}
            />
        </svg>
    );
};
